import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const HOUSE = {
  nickname: 'PRODUCTS.HOUSE.nickname',
  LIST_OF_OBJECTS: ['houseAdditionalBuildings', 'houseWithContents'],
  properties: [
    { name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern(/^\d+$/)
      ]]
    },
    { name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
    { name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.3', value: '3000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.5', value: '5000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.7', value: '7000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.10', value: '10000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.15', value: '15000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE_HOUSE.25', value: '25000' }
        ]
      }
    },
    { name: 'houseSumInsuredType', key: 'SUM_INSURED_TYPE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
        ]
      }
    },
    { name: 'houseSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.YES', value: 'true' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.NO', value: 'false' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_IS_RENTED.PARTIAL', value: 'PARTIAL' },
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseRotAndAnimalDamage', key: 'HOUSE_ROT_AND_ANIMAL_DAMAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'objectAddress', key: 'OBJECT_ADDRESS', group: 'OBJECT_INFO' },
    { name: 'objectZipCode', key: 'OBJECT_ZIP_CODE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.required,
        Validators.pattern('[0-9]{4}$')
      ]]
    },
    { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.HOUSE', value: 'HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CHAIN_DETACHED_HOUSE', value: 'CHAIN_DETACHED_HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.TERRACED_HOUSE', value: 'TERRACED_HOUSE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.DUPLEX', value: 'DUPLEX' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.ADDITIONAL_BUILDING', value: 'ADDITIONAL_BUILDING' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CABIN', value: 'CABIN' }
        ]
      }
    },
    { name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'houseWithContents', key: 'HOUSE_WITH_CONTENTS', group: 'INSURANCE_INFO',
      values: [
        {
          name: 'contentsCover',
          key: 'CONTENTS_COVER',

          // TODO: Use, when contentsCover property will be part of calculation logic
          // inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          // validator: ['', [
          //   Validators.required
          // ]],
          // settings: {
          //   list: [
          //     { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
          //     { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
          //   ]
          // }
        },
        {
          name: 'productPackage',
          key: 'HOUSE_CONTENT_PRODUCT_PACKAGE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
            ]
          }
        },
        {
          name: 'productSumInsured', key: 'HOUSE_CONTENT_SUM_INSURED', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.TEL,
          validator: ['', [
            Validators.required
          ]],
        }
      ]
    },
    { name: 'contentMobileCoverType', key: 'CONTENT_MOBILE_COVER_TYPE', group: 'INSURANCE_INFO' },
    { name: 'objectZipArea', key: 'OBJECT_ZIP_AREA', group: 'OBJECT_INFO' },
    { name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
        ]
      }
    },
    { name: 'buildingUnUsed', key: 'BUILDING_UNUSED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED.19', value: '19' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED.30', value: '30' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED.40', value: '40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED.50', value: '50' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED.51', value: '51' }
        ]
      }
    },
    { name: 'houseAdditionalBuildings', key: 'HOUSE_ADDITIONAL_BUILDINGS', group: 'OBJECT_INFO',
      values: [
        {
          name: 'houseBuildingMaterials',
          key: 'BUILDING_MATERIALS',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
            ]
          }
        },
        {
          name: 'houseSumInsuredType',
          key: 'HOUSE_SUM_INSURED_TYPE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
            ]
          }
        },
        {
          name: 'houseBuildingType',
          key: 'BUILDING_TYPE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_NOT_ISOLATED', value: 'SHED_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_ISOLATED', value: 'GARAGE_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_NOT_ISOLATED', value: 'GARAGE_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CARPORT', value: 'CARPORT' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.LOGCABIN_MACHINE', value: 'LOGCABIN_MACHINE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.LOGCABIN_BY_HAND', value: 'LOGCABIN_BY_HAND' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_ISOLATED', value: 'SHED_ISOLATED' }
            ]
          }
        },
        {
          name: 'houseSquareMeters',
          key: 'SQUARE_METERS',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseAdditionalBuildingBuiltYear',
          key: 'HOUSE_ADDITIONAL_BUILDING_BUILT_YEAR',
          inputType: INPUT_TYPES_CONFIG.DATE,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            dateView: 'multi-years'
          }
        },
        {
          name: 'houseAdditionalBuildingProductPackage',
          key: 'HOUSE_ADDITIONAL_BUILDING_PRODUCT_PACKAGE'
        }
      ]
    },
    { name: 'houseSMAlarmBurglar', key: 'HOUSE_SM_ALARM_BURGAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMElectricalControl', key: 'HOUSE_SM_ELECTRICAL_CONTROL', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMPipeInPipe', key: 'HOUSE_SM_PIPE_IN_PIPE', group: 'OBJECT_INFO' },
    { name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMNoCella', key: 'HOUSE_SM_NO_CELLA', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMFlatRoof', key: 'HOUSE_SM_FLAT_ROOF', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMAutomaticWaterStop', key: 'HOUSE_SM_AUTOMATIC_WATER_STOP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'houseSMAutomaticCircuitBreaker', key: 'HOUSE_SM_AUTOMATIC_CIRCUIT_BREAKER', group: 'OBJECT_INFO' },
    { name: 'houseSurgeProtectionInFuseCabinet', key: 'HOUSE_SURGE_PROTECTION_IN_FUSE_CABINET', group: 'OBJECT_INFO' }
  ],
  icon: 'house'
};
